export default [
  {
    path: 'on-boarder',
    name: 'on-border',
    redirect: { name: 'workflow-stage' },
    component: () => import('@/modules/global-settings/onboarder/layout/OnboarderSettingLayout.vue'),
    meta: {
      requiredPrivileges:  ['On-Boarder Settings']
    },
    children: [  
      {
        path: 'workflow-stage',
        name: 'workflow-stage',
        component: () =>
          import('@/modules/global-settings/onboarder/views/WorkflowStage.vue')
      },
      {
        path: 'account-classifications',
        name: 'account-classifications',
        component: () =>
          import(
            '@/modules/global-settings/onboarder/views/AccountClassifications.vue'
          )
      },
      {
        path: 'application-data-requirements',
        name: 'application-data-requirements',
        component: () =>
          import(
            '@/modules/global-settings/onboarder/views/ApplicationDataRequirements.vue'
          )
      },
      {
        path: 'due-diligence',
        name: 'due-diligence',
        component: () =>
          import('@/modules/global-settings/onboarder/views/DueDiligenceTypes.vue')
      },
      {
        path: 'account-product-settings',
        name: 'account-product-settings',
        component: () =>
          import(
            '@/modules/global-settings/onboarder/views/AccountProductSettings.vue'
          )
      },
      {
        path: 'services-settings',
        name: 'services-settings',
        component: () =>
          import('@/modules/global-settings/onboarder/views/ServicesSettings.vue')
      },
      {
        path: 'due-diligence-actions-settings',
        name: 'due-diligence-actions-settings',
        component: () =>
          import(
            '@/modules/global-settings/onboarder/views/DueDiligenceActionsSettings.vue'
          )
      },
      {
        path: 'document-settings',
        name: 'document-settings',
        component: () =>
          import('@/modules/global-settings/onboarder/views/DocumentSettings.vue')
      },
      {
        path: 'form-data-settings',
        name: 'form-data',
        component: () =>
          import('@/modules/global-settings/onboarder/views/FormDataSettings.vue')
      }
    ]
  }
];
